module.exports = __webpack_public_path__ + "static/media/p-logo-fet.11c69654.svg";